export default __webpack_public_path__ + "static/media/include_0@3x.a7c72944.jpg";